import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip
} from '@material-ui/core';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';

const TableHeaderCell = React.memo(({ label, tooltip }) => (
    <TableCell align="center">
        {label} &nbsp;
        <Tooltip title={tooltip} placement="top">
            <i className="fa fa-info-circle" />
        </Tooltip>
    </TableCell>
));

const TableField = React.memo(({ item, fieldConfig }) => (
    <TableCell>
        <Field
            name={`${item}.${fieldConfig.id}`}
            id={`${item}.${fieldConfig.id}`}
            type="text"
            component={CustomInput}
            placeholder={fieldConfig.placeholder}
            onlyNumbers="true"
        />
    </TableCell>
));
const STREAMING_COLUMNS = [
    {
        id: 'streamDays',
        label: 'Stream Days',
        tooltip: 'Must Above 0, Range From 1 To 9999.',
        placeholder: 'Stream Days'
    },
    {
        id: 'streamHours',
        label: 'Stream Minutes',
        tooltip: 'Must Above 0, Range From 1 To 9999.',
        placeholder: 'Stream Minutes'
    },
    {
        id: 'maxRevenue',
        label: 'Max Revenue($)',
        tooltip: 'Must Above 0, Range From 1 To 99999999.',
        placeholder: 'Max Revenue'
    },
    {
        id: 'prizePool',
        label: 'Prize Pool($)',
        tooltip: 'Must Above 0, Range From 1 To 99999999.',
        placeholder: 'Prize Pool'
    }
];
const StreamingSplitTable = ({ fields, questForm, questStarted, isNew }) => {
    const showActionColumn = (!questStarted || isNew) &&
        (questForm?.values?.rankTiers?.length > 0 || questForm?.values?.splitTiers?.length > 1);
    const handleDelete = React.useCallback((index) => {
        if (window.confirm('Are you sure you want to remove this tier?')) {
            fields.remove(index);
        }
    }, [fields]);
    return (
        <>
            <TableHead>
                <TableRow>
                    {STREAMING_COLUMNS.map(column => (
                        <TableHeaderCell
                            key={column.id}
                            label={column.label}
                            tooltip={column.tooltip}
                        />
                    ))}
                    {showActionColumn && (
                        <TableHeaderCell
                            label="Action"
                            tooltip="You can delete this tier."
                        />
                    )}
                </TableRow>
            </TableHead>
            <TableBody>
                {fields.map((item, index) => (
                    <TableRow key={index}>
                        {STREAMING_COLUMNS.map(column => (
                            <TableField
                                key={`${item}.${column.id}`}
                                item={item}
                                fieldConfig={column}
                            />
                        ))}
                        {showActionColumn && (
                            <TableCell align="center">
                                <div className="RepeaterWrapper__item__new">
                                    <button
                                        className="RepeaterWrapper__item-remove-new"
                                        type="button"
                                        onClick={() => handleDelete(index)}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </TableCell>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </>
    );
};

StreamingSplitTable.propTypes = {
    fields: PropTypes.object.isRequired,
    questForm: PropTypes.object,
    questStarted: PropTypes.bool,
    isNew: PropTypes.bool
};

export default React.memo(StreamingSplitTable);